import { Component, ViewChild } from '@angular/core';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { EmployeeRegistrationService } from '../../../Model/EmployeeRegistration/employee-registration.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonService } from '../../../Model/Common/common.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbProgressbarModule, NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { MusterAttendanceService } from '../../../Model/MusterAttendance/muster-attendance.service';
import { NgSelectModule } from '@ng-select/ng-select';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-sub-contractor',
  standalone: true,
  imports: [CommonModule, RouterModule, DataTablesModule, NgbProgressbarModule, FormsModule, NgbDropdownModule, NgSelectModule],
  templateUrl: './sub-contractor.component.html',
  styleUrl: './sub-contractor.component.scss'
})
export class SubContractorComponent {
  isDisabled: boolean = false;
  EmployeeData = [] as any;
  Vendors = [] as any;
  Filter = {
    SelectType: "EW",
    EmpMasterId: null,
    EmpCode: null,
    EmpName: null,
    VendorId: null,
    SubType: 'A'
  }

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private employeeRegistration: EmployeeRegistrationService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private modalService: NgbModal,
    private toast: ToastService,
    private musterAttendance: MusterAttendanceService,
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }


  ngOnInit(): void {
    this.ESS_FillComboOAS('Vendor');
    this.ESS_EmployeeSubcontracterSelect();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  FilterValidate(form: any) {
    if (form.valid) {
      this.ESS_EmployeeSubcontracterSelect();
    }
    else {
      form.submitted = true;
    }
  }

  async ESS_EmployeeSubcontracterSelect() {
    this.isDisabled = true;
    this.employeeRegistration.ESS_EmployeeSubcontracterSelect(this.Filter).subscribe({
      next: async (response) => {
        this.EmployeeData = Object.values(response.Table)
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_FillComboOAS(Type: String) {
    this.isDisabled = true;
    return this.musterAttendance.ESS_FillComboOAS({ 'SelectType': Type }).subscribe({
      next: (response) => {
        if (response.Table) {
          if (Type == "Vendor") {
            this.Vendors = response.Table;
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  reset() {
    this.Filter = {
      SelectType: "EW",
      EmpMasterId: null,
      EmpCode: null,
      EmpName: null,
      VendorId: null,
      SubType: 'A'
    }
    this.clear();
  }

  async ExportExcel() {
    let excelData = [];
    console.log(this.EmployeeData);
    if (this.EmployeeData.length > 0) {
      try {
        this.isDisabled = true;
        await new Promise(f => setTimeout(f, 500));

        excelData = JSON.parse(JSON.stringify(this.EmployeeData));
        excelData.forEach(function (x: any) {
          delete x.AadharAttachment, delete x.AadharVerificationId, delete x.Aadhar_GenderId
            , delete x.Aadhar_Image, delete x.BranchMasterID, delete x.ClientGroupMasterId, delete x.DesignationMasterID, delete x.DutyMasterID,
            delete x.EmpMasterID, delete x.GenderMasterID, delete x.Photo, delete x.ServiceTypeID, delete x.ShiftMasterID, delete x.SiteMasterID, delete x.VendorId
        });
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, 'ExcelSheet.xlsx');
        this.isDisabled = false;
      } catch (e) {
        this.isDisabled = false;
      }
    }
  }

  clear() {
    this.EmployeeData = Object.values([])
    try {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } catch (e) { }
  }
}
